import { Badge } from "@/components/ui/badge";
import { Bell, BellOff } from "lucide-react";

interface NotificationPermissionBadgeProps {
  permissionStatus: NotificationPermission;
}

const NotificationPermissionBadge = ({ permissionStatus }: NotificationPermissionBadgeProps) => {
  switch (permissionStatus) {
    case 'granted':
      return <Badge variant="default" className="text-xs"><Bell className="w-3 h-3 mr-1" />Enabled</Badge>;
    case 'denied':
      return <Badge variant="destructive" className="text-xs"><BellOff className="w-3 h-3 mr-1" />Blocked</Badge>;
    default:
      return <Badge variant="secondary" className="text-xs">Not Set</Badge>;
  }
};

export default NotificationPermissionBadge;